import { render } from "./Font.vue?vue&type=template&id=25ec4776&scoped=true"
import script from "./Font.vue?vue&type=script&lang=js"
export * from "./Font.vue?vue&type=script&lang=js"

import "./Font.vue?vue&type=style&index=0&id=25ec4776&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25ec4776"]])

export default __exports__